module.exports = __webpack_public_path__ + "static/img/07.0768371.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news8/07.jpg
// module id = X0un
// module chunks = 1